/*
 * Copyright (c) 2017 OCLC, Inc. All Rights Reserved.
 *
 * OCLC proprietary information: the enclosed materials contain proprietary information of OCLC Online Computer
 * Library Center, Inc. and shall not be disclosed in whole or in any part to any third party or used by any person
 * for any purpose, without written consent of OCLC, Inc.  Duplication of any portion of these materials shall include
 * this notice.
 */
import React from 'react';
import {FormattedHTMLMessage, injectIntl} from 'react-intl';

const _MainView = (props) => {
  return (
    <p>
      <FormattedHTMLMessage id="MainView.welcome"
        defaultMessage={'If there are not menu choices in the left column, or the choices ' +
            'are not what you are expecting, return to the Service Configuration Home Page ' +
            'and select a different login option.'}/>
    </p>
  );
};

export const MainView = injectIntl(_MainView);



// WEBPACK FOOTER //
// ./src/MainView/MainView.js